import React, { FC, useState, useEffect } from 'react'
import {
  Container,
  LogoImg,
  TitleDivider,
  ArrowCloseContainer,
  ArrowCloseImg,
  ClientSwitcher,
  ClientSwitcherWrapper,
  ClientSwitcherName,
  ClientSwitcherLabel,
  ClientSwitcherValue,
  MobileOverlay,
} from './styles'
import { useTheme } from 'styled-components'
import { useAuth } from '../../context/user.context'

import HomeIcon from './icons/figma-home-default.svg'
import HomeHoverIcon from './icons/home-hover.svg'
import ActiveHomeIcon from './icons/active-home.svg'
import InstanceIcon from './icons/figma-instances-default.svg'
import InstanceHoverIcon from './icons/instances-hover.svg'
import ActiveInstanceIcon from './icons/active-instances.svg'
import VolumesIcon from './icons/figma-volumes-default.svg'
import VolumesHoverIcon from './icons/volumes-hover.svg'
import ActiveVolumesIcon from './icons/active-volumes.svg'
import ImagesIcon from './icons/figma-images-default.svg'
import ImagesHoverIcon from './icons/images-hover.svg'
import ActiveImagesIcon from './icons/active-images.svg'
import SSHKeysIcon from './icons/figma-ssh-keys-default.svg'
import SSHKeysHoverIcon from './icons/ssh-keys-hover.svg'
import ActiveSSHKeysIcon from './icons/active-sshKeys.svg'
import NetworksIcon from './icons/figma-networks-default.svg'
import NetworksHoverIcon from './icons/network-hover.svg'
import ActiveNetworksIcon from './icons/active-networks.svg'
import KubernetesIcon from './icons/figma-kubernetes-default.svg'
import KubernetesHoverIcon from './icons/kubernetes-hover.svg'
import ActiveKubernetesIcon from './icons/active-kubernetes.svg'
import SecurityIcon from './icons/figma-security-groups-default.svg'
import SecurityHoverIcon from './icons/security-group-hover.svg'
import ActiveSecurityIcon from './icons/active-securityGroups.svg'
import BalancersIcon from './icons/figma-load-balancers-default.svg'
import BalancersHoverIcon from './icons/load-balancer-hover.svg'
import ActiveBalancersIcon from './icons/active-loadBalancers.svg'
import FloatingIcon from './icons/figma-floating-ips-default.svg'
import FloatingHoverIcon from './icons/floating-ip-hover.svg'
import ActiveFloatingIcon from './icons/active-floatingIps.svg'
import BillingIcon from './icons/figma-billing-default.svg'
import BillingHoverIcon from './icons/billing-hover.svg'
import ActiveBillingIcon from './icons/active-billing.svg'
import SupportIcon from './icons/figma-support-default.svg'
import SupportHoverIcon from './icons/support-hover.svg'
import ActiveSupportIcon from './icons/active-support.svg'
import AffiliateIcon from './icons/affiliate-default.svg'
import BareMetalHoverIcon from './icons/bare-metal-hover.svg'
import BareMetalIcon from './icons/figma-bare-metal-default.svg'
import ActiveBareMetalIcon from './icons/active-bareMetal.svg'
import RouterIcon from './icons/figma-routers-default.svg'
import RouterHoverIcon from './icons/router-hover.svg'
import ActiveRouterIcon from './icons/active-routers.svg'
import PortIcon from './icons/figma-ports-default.svg'
import PortHoverIcon from './icons/port-hover.svg'
import ActivePortIcon from './icons/active-ports.svg'
import ObjStoreIcon from './icons/figma-object-storage-default.svg'
import ObjStoreHoverIcon from './icons/obj-store-hover-ic.svg'
import ActiveObjStoreIcon from './icons/active-objectStorage.svg'
import { useTranslation } from 'react-i18next'
import SideBarTab from '../side-bar-item'
import ArrowClose from './icons/arrowClose.svg'
import { useUi } from '../../context/ui.context'
import { useLocation, useNavigate } from 'react-router'
import LogoSmall from './logo-cube.svg'
import LogoSmallDark from './logo-cube.svg'
import LogoDark from './logo-white.svg'
import Logo from './logo-black.svg'
import OperationsHoverIcon from './icons/operations-hover.svg'
import OperationsIcon from './icons/figma-operations-default.svg'
import ActiveOperationsIcon from './icons/active-operations.svg'
import ActiveAffiliateIcon from './icons/active-affiliate.svg'
import {
  authService,
  floatingIpService,
  imageService,
  instanceService,
  loadBalancerService,
  networkService,
  routerService,
  securityService,
  volumeService,
} from '../../api'
import ClientsIcon from '../../icons/clients.svg'
import TopProgress from '../TopBarProgress'
// import {
//   AffiliateIcon,
//   ArrowClose,
//   BareMetalIcon,
// } from './icons'
import { menuPermissionSurfaces, usePermission } from '../../permissions'

const SideBar:FC = () => {
  const navigate = useNavigate()
  const {t} = useTranslation()
  const {user} = useAuth()
  const { evaluateSurface } = usePermission()
  const {setSmallBar, smallBar, viewAlert} = useUi()
  const [loadingNav, setLoadingNav] = useState<boolean>(false)
  const [activeText, setACtiveText] = useState<boolean>(false)
  const location = useLocation()
  useEffect(() => {
    if(!smallBar) {
      const timeout = window.setTimeout(() => {
        setACtiveText(true)
      },150)
      return () => window.clearTimeout(timeout)
    } else {
      setACtiveText(false)
    }
  },[smallBar])
  useEffect(() => {
    if(window.innerWidth <= 768){
      setSmallBar(true)
    }
  },[location.pathname, setSmallBar])
  const changeSizeBar = () => {
    setSmallBar(!smallBar)
  }
  const theme:any = useTheme()
  const canView = (surface: typeof menuPermissionSurfaces[keyof typeof menuPermissionSurfaces]) =>
    evaluateSurface(surface).allowed
  const canViewInstances = canView(menuPermissionSurfaces.instances)
  const canViewGpu = canView(menuPermissionSurfaces.gpu)
  const canViewVolumes = canView(menuPermissionSurfaces.volumes)
  const canViewVolumeBackups = canView(menuPermissionSurfaces.volumeBackups)
  const canViewImages = canView(menuPermissionSurfaces.images)
  const canViewObjectStorage = canView(menuPermissionSurfaces.objectStorage)
  const canViewKubernetes = canView(menuPermissionSurfaces.kubernetes)
  const canViewBareMetal = canView(menuPermissionSurfaces.bareMetal)
  const canViewNetworks = canView(menuPermissionSurfaces.networks)
  const canViewPorts = canView(menuPermissionSurfaces.ports)
  const canViewRouters = canView(menuPermissionSurfaces.routers)
  const canViewSecurityGroups = canView(menuPermissionSurfaces.securityGroups)
  const canViewLoadBalancers = canView(menuPermissionSurfaces.loadBalancers)
  const canViewFloatingIps = canView(menuPermissionSurfaces.floatingIps)
  const canViewBilling = canView(menuPermissionSurfaces.billing)
  const canViewSshKeys = canView(menuPermissionSurfaces.sshKeys)
  const canViewOperations = canView(menuPermissionSurfaces.operations)
  const canViewClients = canView(menuPermissionSurfaces.clients)
  const showComputeSection = canViewInstances || canViewGpu || canViewVolumes || canViewVolumeBackups || canViewImages || canViewObjectStorage
  const showNetworkSection = canViewNetworks || canViewPorts || canViewRouters || canViewSecurityGroups || canViewLoadBalancers || canViewFloatingIps
  const checkMenu = async (url:string) => {
    switch (url) {
      case 'instances':
        return await instanceService.getInstanceList({
            page:1,
            ordering:'',
            pageSize:10
          })
      case 'volumes':
        return await volumeService.getVolumeList({
            page:1,
            ordering:'',
            pageSize:10
          })
      case 'images':
        return await imageService.getImagesList({
          page:1,
          ordering:'',
          pageSize:10
        })
      case 'networks':
        return await networkService.getAllNetworks({
          page:1,
          ordering:'',
          pageSize:10
        })
      case 'routers':
        return await routerService.getRouters({
          page:1,
          ordering:'',
          pageSize:10
        })
      case 'security-groups':
        return await securityService.getSecurityList({
          page:1,
          ordering:'',
          pageSize:10
        })
      case 'floating-ips':
        return await floatingIpService.getIps({
          page:1,
          ordering:'',
          pageSize:10
        })
      case 'load-balancers':
        return await loadBalancerService.getList({
          page:1,
          ordering:'',
          pageSize:10
        })
      default:
        return await authService.getUser()
    }
  }
  const checkClient = async (route:string, navigateTo:string) => {
    setLoadingNav(true)
    if(!user.user.active_client){
      setLoadingNav(false)
      navigate('/complete-registration')
      return
    }
    try {
      await checkMenu(navigateTo?.replace('/', ''))
      await navigate(navigateTo)
    } catch (err:any) {
      viewAlert({
        severity:'error',
        message:err?.response?.data?.detail || `${t("ERROR_OCCURRED")}`,
      })
      return false
      // navigate('/home')
    } finally {
      setLoadingNav(false)
    }
  }
  return(
    <>
      <MobileOverlay active={smallBar} onClick={() => setSmallBar(true)} />
      <Container
        data-test-id='sidebar-container'
        active={smallBar}
      >
      <TopProgress loading={loadingNav}/>
      <ArrowCloseContainer
        active={smallBar}
        onClick={changeSizeBar}
      >
        <ArrowCloseImg
          active={smallBar}
          src={ArrowClose}
        />
        {/* <ArrowCloseImg active={smallBar}>
          <ArrowClose styles={`${styles.iconArrow} ${smallBar ? styles.iconArrowArrow : ''}`}/>

        </ArrowCloseImg> */}
      </ArrowCloseContainer>
      {/* <LogoImg src={Logo}/> */}
      <LogoImg onClick={() => {
        window.open('https://onecloudplanet.com/')
        // navigate('/home')
      }} active={!activeText}
        src={
          theme.isDark ? 
            !activeText ? LogoSmallDark : LogoDark
          :
            !activeText ? LogoSmall : Logo
        }
      />
          <SideBarTab
            href={'/home'}
            isFirst
            isSmall={smallBar}
            active={location.pathname?.includes('/home')}
            defaultIcon={HomeIcon}
            hoverIcon={HomeHoverIcon}
            activeIcon={ActiveHomeIcon}
            title={t("HOME")}
            activeText={activeText}
            onClick={() => navigate('/home')}
          />

          {showComputeSection && (
            <TitleDivider active={!activeText}>
              {!activeText ? '_' : t("CLOUD_COMPUTE")}
            </TitleDivider>
          )}
          {canViewInstances && (
            <SideBarTab
              href='/instances'
              isSmall={smallBar}
              active={location.pathname?.includes('/instances')}
              defaultIcon={InstanceIcon}
              hoverIcon={InstanceHoverIcon}
              activeIcon={ActiveInstanceIcon}
              title={t("INSTANCES")}
              activeText={activeText}
              onClick={() => checkClient('openstack/instances', '/instances')}
            />
          )}
          {canViewGpu && (
            <SideBarTab
              href='/gpu'
              isSmall={smallBar}
              active={location.pathname?.includes('/gpu')}
              defaultIcon={InstanceIcon}
              hoverIcon={InstanceHoverIcon}
              activeIcon={ActiveInstanceIcon}
              title={t("GPU")}
              activeText={activeText}
              onClick={() => checkClient('gpu', '/gpu')}
            />
          )}
          {canViewVolumes && (
            <SideBarTab
              href={'/volumes'}
              isSmall={smallBar}
              active={location.pathname?.includes('/volumes')}
              defaultIcon={VolumesIcon}
              hoverIcon={VolumesHoverIcon}
              activeIcon={ActiveVolumesIcon}
              title={t("VOLUMES")}
              onClick={() => checkClient('openstack/volumes', '/volumes')}
              activeText={activeText}
            />
          )}
          {canViewVolumeBackups && (
            <SideBarTab
              href={'/volume-backups'}
              isSmall={smallBar}
              active={location.pathname?.includes('/volume-backups')}
              defaultIcon={VolumesIcon}
              hoverIcon={VolumesHoverIcon}
              activeIcon={ActiveVolumesIcon}
              title={t("VOLUME_BACKUPS")}
              onClick={() => checkClient('openstack/volume-backups', '/volume-backups')}
              activeText={activeText}
            />
          )}
          {canViewImages && (
            <SideBarTab
              href={'/images'}
              isSmall={smallBar}
              active={location.pathname?.includes('/images')}
              defaultIcon={ImagesIcon}
              hoverIcon={ImagesHoverIcon}
              activeIcon={ActiveImagesIcon}
              title={t("IMAGES")}
              onClick={() => checkClient('openstack/images', '/images')}
              activeText={activeText}
            />
          )}
          {canViewObjectStorage && localStorage.getItem('region_ocp_zone') !== 'pl-1' && localStorage.getItem('region_ocp_zone') !== 'nl-1' && (
            <SideBarTab
              href={'/object-storage'}
              isSmall={smallBar}
              active={location.pathname?.includes('/object-storage')}
              defaultIcon={ObjStoreIcon}
              hoverIcon={ObjStoreHoverIcon}
              activeIcon={ActiveObjStoreIcon}
              title={t("OBJECT_STORAGE")}
              onClick={() => checkClient('openstack/images', '/object-storage')}
              activeText={activeText}
            />
          )}
          {(canViewKubernetes || canViewBareMetal) && (
            <TitleDivider active={!activeText}>
              {!activeText ? '_' : t("CONTAINERS")}
            </TitleDivider>
          )}
          {canViewKubernetes && (
            <SideBarTab
              href={'/kubernetes'}
              isSmall={smallBar}
              active={location.pathname?.includes('/kubernetes')}
              onClick={() => checkClient('kubernetes', '/kubernetes')}
              defaultIcon={KubernetesIcon}
              hoverIcon={KubernetesHoverIcon}
              activeIcon={ActiveKubernetesIcon}
              title={t("KUBERNETES_CLUSTERS")}
              isBeta
              iconGap={15}
              activeText={activeText}
            />
          )}
          {canViewBareMetal && (
            <SideBarTab
              href={'/bare-metal'}
              isSmall={smallBar}
              active={location.pathname?.includes('/bare-metal')}
              onClick={() => checkClient('bare-metal', '/bare-metal')}
              defaultIcon={BareMetalIcon}
              hoverIcon={BareMetalHoverIcon}
              activeIcon={ActiveBareMetalIcon}
              title={t("BARE_METAL")}
              topOffset={30}
              activeText={activeText}
            />
          )}
          {showNetworkSection && (
            <TitleDivider active={!activeText}>
              {!activeText ? '_' : t("NETWORK")}
            </TitleDivider>
          )}
          {canViewNetworks && (
            <SideBarTab
              href={'/networks'}
              isSmall={smallBar}
              active={location.pathname?.includes('/networks')}
              defaultIcon={NetworksIcon}
              hoverIcon={NetworksHoverIcon}
              activeIcon={ActiveNetworksIcon}
              onClick={() => checkClient('openstack/networks', '/networks')}
              title={t("NETWORKS")}
              activeText={activeText}
            />
          )}
          {canViewRouters && (
            <SideBarTab
              href={'/routers'}
              isSmall={smallBar}
              active={location.pathname?.includes('/routers')}
              defaultIcon={RouterIcon}
              onClick={() => checkClient('openstack/routers', '/routers')}
              hoverIcon={RouterHoverIcon}
              activeIcon={ActiveRouterIcon}
              title={t("ROUTERS")}
              activeText={activeText}
            />
          )}
          {canViewPorts && (
            <SideBarTab
              href={'/ports'}
              isSmall={smallBar}
              active={location.pathname?.includes('/ports')}
              defaultIcon={PortIcon}
              hoverIcon={PortHoverIcon}
              activeIcon={ActivePortIcon}
              title={t("PORTS")}
              onClick={() => navigate('/ports')}
              activeText={activeText}
            />
          )}
          {canViewSecurityGroups && (
            <SideBarTab
              href={'/security-groups'}
              isSmall={smallBar}
              active={location.pathname?.includes('/security-groups') && !location.pathname?.includes('/instances')}
              defaultIcon={SecurityIcon}
              onClick={() => checkClient('openstack/security-groups', '/security-groups')}
              hoverIcon={SecurityHoverIcon}
              activeIcon={ActiveSecurityIcon}
              title={t("SECURITY_GROUPS")}
              activeText={activeText}
            />
          )}
          {canViewLoadBalancers && (
            <SideBarTab
              href={'/load-balancers'}
              isSmall={smallBar}
              active={location.pathname?.includes('/load-balancers')}
              defaultIcon={BalancersIcon}
              onClick={() => checkClient('openstack/load-balancers', '/load-balancers')}
              hoverIcon={BalancersHoverIcon}
              activeIcon={ActiveBalancersIcon}
              title={t("LOAD_BALANCERS")}
              activeText={activeText}
            />
          )}
          {canViewFloatingIps && (
            <SideBarTab
              href={'/floating-ips'}
              isSmall={smallBar}
              active={location.pathname?.includes('/floating-ips')}
              defaultIcon={FloatingIcon}
              hoverIcon={FloatingHoverIcon}
              activeIcon={ActiveFloatingIcon}
              onClick={() => checkClient('openstack/floating-ips', '/floating-ips')}
              title={t("FLOATING_IPS")}
              activeText={activeText}
            />
          )}
          <TitleDivider active={!activeText} style={activeText ? {marginBottom: 0} : undefined}>
            <div style={!activeText ? {} : {display:'none'}}>
              _
            </div>
          </TitleDivider>
          {canViewBilling && (
            <SideBarTab
              href={'/billing/overview'}
              isSmall={smallBar}
              active={location.pathname?.includes('/billing')}
              defaultIcon={BillingIcon}
              onClick={() => checkClient('/billing', '/billing/overview')}
              hoverIcon={BillingHoverIcon}
              activeIcon={ActiveBillingIcon}
              title={t("BILLING")}
              activeText={activeText}
              isDown={true}
            />
          )}
          {canViewSshKeys && (
            <SideBarTab
              href={'/ssh-keys'}
              isSmall={smallBar}
              active={location.pathname?.includes('/ssh-keys')}
              defaultIcon={SSHKeysIcon}
              hoverIcon={SSHKeysHoverIcon}
              activeIcon={ActiveSSHKeysIcon}
              onClick={() => checkClient('/ssh-keys', '/ssh-keys')}
              title={t("SSH_KEYS")}
              activeText={activeText}
            />
          )}
          {canViewBilling && (
            <SideBarTab
              href={'/affiliate'}
              isSmall={smallBar}
              active={location.pathname?.includes('/affiliate')}
              onClick={() => navigate('/affiliate')}
              defaultIcon={AffiliateIcon}
              hoverIcon={AffiliateIcon}
              activeIcon={ActiveAffiliateIcon}
              title={t("AFFILIATE")}
              activeText={activeText}
              viewIfNoClient={true}
            />
          )}
          <SideBarTab
            href={'/support'}
            isSmall={smallBar}
            active={location.pathname?.includes('/support')}
            onClick={() => navigate('/support')}
            defaultIcon={SupportIcon}
            hoverIcon={SupportHoverIcon}
            activeIcon={ActiveSupportIcon}
            title={t("SUPPORT")}
            activeText={activeText}
            viewIfNoClient={true}
          />
          {canViewOperations && (
            <SideBarTab
              href={'/operations'}
              isSmall={smallBar}
              active={location.pathname?.includes('/operations')}
              onClick={() => navigate('/operations')}
              defaultIcon={OperationsIcon}
              hoverIcon={OperationsHoverIcon}
              activeIcon={ActiveOperationsIcon}
              title={t("OPERATIONS")}
              activeText={activeText}
            />
          )}
          {canViewClients && (
            <ClientSwitcherWrapper>
              <ClientSwitcher active={smallBar} onClick={() => navigate('/clients')}>
                <img src={ClientsIcon} alt="" style={{width:'20px', height:'20px', flexShrink:0}}/>
                {activeText && (
                  <ClientSwitcherName>
                    <ClientSwitcherLabel>{t("ACTIVE_CLIENT")}</ClientSwitcherLabel>
                    <ClientSwitcherValue>
                      {user?.user?.active_client
                        ? user.user.clients?.find((c:any) => c.id === user.user.active_client)?.long_name || `#${user.user.active_client}`
                        : t("SELECT_CLIENT")
                      }
                    </ClientSwitcherValue>
                  </ClientSwitcherName>
                )}
              </ClientSwitcher>
            </ClientSwitcherWrapper>
          )}
      </Container>
    </>
  )
}

export default SideBar
